var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container",attrs:{"id":"policy"}},[_c('h1',{staticClass:"big-title"},[_vm._v("Politique de confidentialité de CodeSnippet")]),_vm._v(" 27 Rue Raoul Servant, Lyon, 69007 , France ")])
}]

export { render, staticRenderFns }